<template>
  <div class="account-data data-wrapper">
    <div class="account-data__content">
      <div class="account-data__item contacts-data-wrapper">
        <div class="label" data-voicetext="Адреса">Адреса</div>
        <div class="info">
          <div class="col-info pl-0">
            <ModelString
                v-if="profileInfo.isPlaceOfBirthSpecial"
                label="Место рождения"
                class="data-model_special-place"
                v-model="profileInfo.placeOfBirthSpecial"
            />
            <ModelAutoComplete
                v-if="!profileInfo.isPlaceOfBirthSpecial && loaded"
                label="Место рождения"
                v-model="profileInfo.placeOfBirth"
                :vizKeyPath="[['value']]"
                :items="autoCompletePlaceOfBirth"
                @debounce-end="getAutoCompletePlaceOfBirth"
                @selected="getFullAddress($event, 'placeOfBirth')"
                @clear="profileInfo.placeOfBirth = null"
            />
            <ModelCheckbox
                v-model="profileInfo.isPlaceOfBirthSpecial"
                label="Особое место рождения"
            />
          </div>
          <div class="col-info">
            <ModelAutoComplete
                v-if="userProfileAge >= 18 && loaded"
                label="Адрес регистрации"
                v-model="profileInfo.regAddress"
                :vizKeyPath="[['value']]"
                :items="autoCompleteRegistrationAddress"
                @debounce-end="getAutoCompleteRegistrationAddress"
                @selected="getFullAddress($event, 'regAddress')"
                @clear="profileInfo.regAddress = null"
            />
          </div>
          <div class="col-info pr-0"></div>
        </div>
      </div>
      <div class="account-data__item account-data__item--relaxed contacts-data-wrapper">

        <div
          class="label"
          data-voicetext="Телефон и электронная почта"
        >Телефон и электронная почта</div>
        <div class="info">
          <div
            class="col-info pl-0 input-container"
          >
            <ModelString
                v-if="profileInfo.regTel"
                label="Регистрационный телефон"
                :disabled="true"
                :disabledValue="true"
                v-model="profileInfo.regTel"
            />
            <TelWithConfirm
                v-if="userProfileAge >= 18"
                :isConfirmed="profileInfo.isTelConfirmed"
                :label="'Дополнительный телефон'"
                :regTel="profileInfo.regTel"
                :tel="profileInfo.tel"
                @change="setConfirmed('tel', $event)"
            />
          </div>
          <div class="col-info input-container">
            <ModelString
                v-if="profileInfo.regEmail"
                label="Регистрационная почта"
                :disabled="true"
                :disabledValue="true"
                v-model="profileInfo.regEmail"
            />
            <EmailWithConfirm
                :isConfirmed="profileInfo.isEmailConfirmed"
                :value="profileInfo.email"
                label="Контактная почта"
                @change="setConfirmed('email', $event)"
            />
          </div>
          <div class="col-info pr-0">
          </div>
          <div
            v-if="userProfileAge < 18"
            class="col-info pl-0 input-container"
          ></div>
        </div>
      </div>
      <div class="account-data__item account-data__item--relaxed contacts-data-wrapper">
        <div
          class="label"
          data-voicetext="Социальные сети"
          >Социальные сети</div>
        <div class="info">
          <div class="pr-0 special-line-height-1">
            <div v-if="isMobile" class="label-gray pb-3">Привязать профиль</div>
            <SocialNetworkInputs ref="socialNetworkInputs" v-model="profileInfo" :key="'sni_' + socialNetworksInputsKey" />
          </div>
        </div>
      </div>
      <div class="account-data__item account-data__item--relaxed contacts-data-wrapper wrapper-last"></div>
      </div>
    <FixedSaveBtn
        v-if="showFixedSaveBtn"
        @close="closeFixedBtn"
    >
        <ActionButton
            @b-action="saveData"
            :b-color="saveButton.color"
            b-t-color="white"
            :b-text="saveButton.fixedText"
            class="save-block__btn--position save-block__btn"
        />
    </FixedSaveBtn>
    <div
        class="save-block"
    >
      <ActionButton
        ref="contactsBtn"
        @b-action="saveData"
        :b-color="saveButton.color"
        b-t-color="white"
        :b-text="saveButton.text"
        class="save-block__btn--position save-block__btn"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from "../../../UI/inputs/ActionButton";
import SocialNetworkInputs from "../../../UI/inputs/SocialNetworkInputs";

import FixedSaveBtn from "../FixedSaveBtn";
import TelWithConfirm from "../../../UI/TelWithConfirm";
import EmailWithConfirm from "../../../UI/EmailWithConfirm";
import ModelAutoComplete from "../../../UI/models/ModelAutoComplete";
import ModelString from "../../../UI/models/ModelString";
import ModelCheckbox from "../../../UI/models/ModelCheckbox";

import { post, qs } from "../../../../tools/http";

import { mapActions, mapGetters, mapMutations } from "vuex";

const getters = ['userProfileAge', 'userProfileInfo', 'isMobile'];

const actions = ['postProfileData'];

// const telConfirmMutations = ['setConfirmedTel'];

export default {
    name: 'WideContactsData',
    data: () => ({
        loaded: false,
        specificPlaceOfBirth: false,
        showFixedSaveBtn: false,
        observer: null,
        autoCompletePlaceOfBirth: [],
        autoCompleteRegistrationAddress: [],
        saveButton: {
            text: 'Сохранить',
            fixedText: 'Сохранить изменения',
            color: '#4663AB',
            status: 'wait',
        },
        profileInfo: {
            placeOfBirth: '',
            placeOfBirthSpecial: '',
            isPlaceOfBirthSpecial: false,
            isTelConfirmed: false,
            isEmailConfirmed: false,
            regAddress: "",
            tel: "",
            email: "",
            regTel: "",
            regEmail: "",
            vk: "",
            ok: "",
            instagram: "",
            fb: "",
            yt: "",
            tiktok: "",
            zen: "",
            telegram: "",
            rutube: "",
            yappy: "",
            tenchat: "",
            maxMessenger: "",
        },
        socialNetworksInputsKey: '',
    }),
    computed: {
        ...mapGetters(getters),
    },
    components: {
        ActionButton,
        SocialNetworkInputs,
        TelWithConfirm,
        EmailWithConfirm,
        ModelAutoComplete,
        ModelString,
        ModelCheckbox,
        FixedSaveBtn,
    },

    methods: {
        ...mapActions(actions),
        closeFixedBtn() {
            this.showFixedSaveBtn = false;
            this.observer ? this.observer.disconnect() : '';
        },
        setConfirmed(key, { value, isConfirmed }) {
            this.$set(this.profileInfo, key, value);
            this.$set(this.profileInfo, `is${key.charAt(0).toUpperCase() + key.slice(1)}Confirmed`, isConfirmed);
        },
        // ...mapMutations('telConfirmation', telConfirmMutations),
        setLocalConfirmedTel({ tel, isTelConfirmed }) {
            this.profileInfo.tel = tel;
            this.profileInfo.isTelConfirmed = isTelConfirmed;
        },
        async saveData() {
            if (this.saveButton.status != 'wait') return;
            const profileInfo = this.$refs.socialNetworkInputs.apply();
            if (profileInfo === null) {
                return;
            }
            this.profileInfo = {...this.profileInfo, ...profileInfo};
            this.socialNetworksInputsKey = Date.now();
            this.saveButton.status = 'wait';
            this.saveButton.color = '#4663AB';
            this.saveButton.text = 'Сохранение...';
            this.saveButton.fixedText = 'Сохранение...';

            try {
                let response = await this.postProfileData({ ...this.profileInfo });
                this.saveButton.status = 'wait';

                if (response === undefined) {
                    this.saveButton.color = '#EAA520';
                    this.saveButton.text = 'Нет изменений';
                    this.saveButton.fixedText = 'Нет изменений';
                } else if (response.status === 'success') {
                    this.saveButton.color = '#238C47';
                    this.saveButton.text = 'Данные сохранены';
                    this.saveButton.fixedText = 'Данные сохранены';
                } else if (response.status === 'error') {
                    this.saveButton.color = '#F7E9F1';
                    this.saveButton.text = 'Ошибка! извините..';
                    this.saveButton.fixedText = 'Ошибка! извините..';
                }

                this.showFixedSaveBtn = false;
                this.observer ? this.observer.disconnect() : '';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            } catch (e) {
                this.saveButton.status = 'wait';
                this.saveButton.color = '#F7E9F1';
                this.saveButton.text = 'Ошибка! извините..';
                this.saveButton.fixedText = 'Ошибка! извините..';

                setTimeout(() => {
                    this.saveButton.text = 'Сохранить';
                    this.saveButton.fixedText = 'Сохранить изменения';
                    this.saveButton.color = '#4663AB';
                }, 2000);
            }
            if(!this.profileInfo.isTelConfirmed) {
                this.setConfirmed('tel', {value: this.profileInfo.tel, isConfirmed: false});
            }
        },

        async getAutoCompleteRegistrationAddress(inputObj) {
            if (inputObj.value === '') {
                this.autoCompleteRegistrationAddress = [];
                return;
            }
            let postParams = [
                'dadata',
                'search',
                qs({ query: inputObj.value, type: 'address' }),
                true,
                { 'content-type': 'application/x-www-form-urlencoded' },
            ];
            let res = await post(...postParams);
            this.autoCompleteRegistrationAddress = res.suggestions;
        },

        async getAutoCompletePlaceOfBirth(inputObj) {
            if (inputObj.value === '') {
                this.autoCompletePlaceOfBirth = [];
                return;
            }
            let postParams = [
                'dadata',
                'search',
                qs({ query: inputObj.value, type: 'address' }),
                true,
                { 'content-type': 'application/x-www-form-urlencoded' },
            ];
            let res = await post(...postParams);
            this.autoCompletePlaceOfBirth = res.suggestions;
        },
        async getFullAddress(item, field) {
            if (item.value === '') {
                this.profileInfo[field].data.federal_district = null;
                return;
            }
            let postParams = [
                'dadata',
                'clean',
                qs({ query: item.value, type: 'address' }),
                true,
                { 'content-type': 'application/x-www-form-urlencoded' },
            ];
            let res = await post(...postParams);
            this.profileInfo[field].data.federal_district =
                res.suggestions[0].data.federal_district;
        },
    },
    async mounted() {
        const cb1 = key => {
            // TODO валидацию firstJob и otherJobs
            if (!this.profileInfo.hasOwnProperty(key)) return;
            this.profileInfo[key] = this.userProfileInfo[key];
        };
        await Object.keys(this.userProfileInfo).forEach(cb1);
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach( (entry) => {
                !entry.isIntersecting && Math.sign(entry.boundingClientRect.top) === 1 ? this.showFixedSaveBtn = true : this.showFixedSaveBtn = false;
            });
        });
        this.$watch('profileInfo', () => {
            this.observer.observe(this.$refs.contactsBtn.$el);
        }, {deep: true});
        this.$nextTick(() => {
            this.loaded = true;
        });
    },
    beforeDestroy() {
        this.observer ? this.observer.disconnect() : '';
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/account-data.scss';

.data-wrapper {

  width: 100%;
  margin-bottom: rem(32);
  background: #ffffff;
  box-shadow: 0 0.3rem 0.5rem rgba(131, 134, 163, 0.12);
  border-radius: rem(10);
  min-height: 20rem;


  .contacts-data-wrapper {

    .label {
      font-size: rem(16);
      line-height: rem(20);
      font-weight: 600;
      margin-bottom: rem(8);
    }
    .label-gray {
      color: #98A0A9;
      font-size: mrem(14);
      font-weight: 600;
    }

    .info {
      display: flex;
      flex-direction: row;
      width: 100%;

      .col-info {
        display: flex;
        flex-direction: column;
        margin-right: rem(32);
        width: 50%;
        flex: 1;

        &:last-child {
          margin-right: 0;
        }

        .specificPlaceOfBirth {
          font-size: 14px;
          &:hover {
            cursor: pointer;
          }
        }
      }
      .pl-0 {
        padding-left: 0;
      }
      .pr-0 {
        padding-right: 0;
      }
      .addPhoneNumberBtn {
        border-radius: 0.2rem;
        border: rem(1) dashed #4663AB;
        width: 100%;
        height: 2.5rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.8rem;
        color: #4663AB;
        cursor: pointer;
      }
    }
  }
}
@import '../../../../styles/variables';
@media (max-width: $vm) {
  .data-wrapper {
    margin: 0;

    .contacts-data-wrapper {
      // margin: 0 0 mrem(32) 0;
      // padding: 0 0 mrem(24) 0;

      .label {
        font-size: mrem(16);
        line-height: mrem(20);
        margin-bottom: mrem(16);
      }

      .info {
        display: flex;
        flex-direction: column;

        .col-info {
          width: 100%;
          margin: 0;
        }

        .social-block {
          margin-top: mrem(24);
        }
      }
    }

    .wrapper-last {
      border: none;
      padding: 0;
      margin: 0;
    }
  }
}

</style>
